import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Unit, File } from '@appbolaget/aware-model';
import { MediaDialogService } from '@components/media/media-dialog.service';
import { environment } from '@env';
import { SecureImagePipe } from '@helpers/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'aw-file-primary-image',
    templateUrl: 'file-primary-image.component.html',
    providers: [SecureImagePipe],
    standalone: true,
    imports: [NgIf, NgTemplateOutlet, MatCardModule, MatButtonModule, TranslateModule, SecureImagePipe],
})
export class FilePrimaryImageComponent implements OnInit {
    @Input() control: AbstractControl;

    @Input() unit: Unit;

    @Input()
    rules: {};

    @Input() plain = false;

    constructor(
        private mediaDialogService: MediaDialogService,
        private secureImgPipe: SecureImagePipe,
    ) {}

    ngOnInit() {}

    getImageById(id: string) {
        return this.secureImgPipe.transform(`${environment.api.url}/@media/${id}?w=400`, this.unit?.uuid);
    }

    removePrimaryImage() {
        this.control.setValue(null);
    }

    async selectPrimaryImage() {
        let options;

        if (this.unit && this.unit instanceof Unit) {
            options = {
                unit: this.unit,
                rules: this.rules,
                multiple: false,
            };
        }

        const dialog = await this.mediaDialogService.open(true, options);

        dialog.afterClosed().subscribe((data: any) => {
            if (data instanceof File) {
                this.control.setValue(data.uuid);
            } else if (Array.isArray(data) && data[0]) {
                this.control.setValue(data[0].uuid);
            }
        });
    }
}
